import classNames from 'classnames';
import * as React from 'react';

// Utils
// Constants
// Actions
// Models
// Interfaces
// Components
// Styles
import './styles/BookingInfoItem.scss';

type Props = React.PropsWithChildren & {
  icon: JSX.Element;
  depName: string;
  depAt: string;
  title?: string;
  arrName?: string;
  arrAt?: string;
  depTime?: string;
  arrTime?: string;
  changeover?: boolean;
};

export const BookingInfoItem: React.FC<Props> = (props) => {
  const { title, icon, depName, arrName, depAt, arrAt, changeover, children, depTime, arrTime } =
    props;

  return (
    <div className="lp-booking-info-item">
      {title && <div className="lp-booking-info-item-title">{title}</div>}
      <div className="lp-booking-info-item-inner">
        <div className="lp-booking-info-item-details">
          <div className="lp-booking-info-item-segment">
            {depTime && <div className="lp-booking-info-item-time">{depTime}</div>}

            <div
              className={classNames('lp-booking-info-item-route', {
                'is--dep': arrName,
                'no--icon': !icon,
              })}>
              {icon}
              <div className="lp-booking-info-item-location">{depName}</div>
              <div className="lp-booking-info-item-date">{depAt}</div>
            </div>
          </div>
          {arrName && (
            <div className="lp-booking-info-item-segment">
              {arrTime && <div className="lp-booking-info-item-time">{arrTime}</div>}
              <div
                className={classNames('lp-booking-info-item-route is--arr', {
                  'is--changeover': changeover,
                })}>
                <div className="lp-booking-info-item-location">{arrName}</div>
                {arrAt && <div className="lp-booking-info-item-date">{arrAt}</div>}
              </div>
            </div>
          )}
        </div>
        {children && <div className="lp-booking-info-item-additional">{children}</div>}
      </div>
    </div>
  );
};
